<template>
  <div class="card">
    <div class="card-body">
        <loading :active.sync="isLoading"
                 :is-full-page="true"
                 color="green"
                 loader="dots"
        ></loading>
      <form action="#" v-on:submit.prevent="externalSearch(searchquery)" class="w-100">
        <div>
          <div class="input-group">
            <input type="text" name="query" class="form-control input-index" v-model="searchquery" placeholder="Шукати у зовнішніх каталогах">
            <div class="input-group-btn">
              <button type="submit" class="btn btn-link button-index"><img src="/theme/icons/search.svg" width="24px"></button>
            </div>
          </div>
          <div class="row w-100 m-b-20 text-center" style="height:10px">
            <div class="invalid-feedback">

            </div>
          </div>
        </div>
      </form>
            <form action="#" class="floating-labels" v-on:submit.prevent="onSubmit">
              <table class="table reader table-books" style="margin-top:20px">
                <thead>
                <tr>
                  <th>
                    <label class="form-checkbox">
                      <input type="checkbox" v-model="selectAll" @click="select">
                      <i class="form-icon"></i>
                    </label>
                  </th>
                  <th>Назва</th>
                  <th>Посилання</th>
                  <th>Тип Сервера</th>
                  <th>Видимість</th>
                  <th class="w-20">Функції</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="i in items">
                  <td>
                    <label class="form-checkbox">
                      <input type="checkbox" :value="i.id" v-model="selected">
                      <i class="form-icon"></i>
                    </label>
                  </td>
                  <td>{{i.name}}</td>
                    <td>{{i.host}}:{{i.port}}/{{i.database}}</td>
                    <td>{{i.type_name}}</td>
                    <td>
                        <span v-if="i.is_visible" style="color:green"><b>Так</b></span>
                        <span v-else style="color:red"><b>Ні</b></span>
                    </td>
                  <td class="text-left">
                      <button v-if="i.library_id" @click="edit(i)" class="btn btn-success" style="width:auto; height:auto; border-radius: 0.25rem">
                          <i class="mdi mdi-pencil"></i> Редагувати
                      </button>
                    <button v-if="i.library_id" @click="deleteServer(i)" class="btn btn-danger" style="">
                      <i class="mdi mdi-close-circle"></i> Видалити
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>
              <div class="form-group">
                <button @click="save()" type="submit" class="btn btn-success btn-lg" style="font-size: 15px;">
                  <i class="mdi mdi-check-circle"></i> Зберегти
                </button>
                <button onclick="window.location.href = '/library/servers/create'"
                        class="btn btn-success w-auto" style="font-size: 15px;letter-spacing: -0.3px;float:right;margin-left:5px">
                  <img src="/theme/icons/add-book.svg" alt="" class="m-r-10">
                  Додати Koha Сервер
                </button>
                <button onclick="window.location.href = '/library/servers/create/z'"
                        class="btn btn-success w-auto" style="font-size: 15px;letter-spacing: -0.3px;float:right;margin-left:5px">
                  <img src="/theme/icons/add-book.svg" alt="" class="m-r-10">
                  Додати Сервер Z39.50
                </button>
              </div>
            </form>
          </div>
        </div>

      </template>

      <script>
        import Loading from 'vue-loading-overlay';

        export default {
          name: "Servers",
          components:{
            Loading
          },
          data: function () {
            return {
              isLoading:false,
              items: [],
              selected: [],
              selectAll: false,
              searchquery: null,
            }
          },
          mounted() {
            this.getServers();
          },
          methods: {
            getServers: function () {
              this.isLoading = true;
              axios.get('/library/servers/get_list')
                .then(response => response.data)
                .then(response => {
                  this.items = response.servers.all;
                  this.selected = response.servers.selected;
                  this.isLoading = false;
                });
            },
            select() {
              this.selected = [];
              if (!this.selectAll) {
                for (let i in this.items) {
                  this.selected.push(this.items[i].id);
                }
              }
            },
            save() {
              axios.post('/library/servers/save', { servers: this.selected })
                  .then(response => response.data)
                  .then(response => Swal('Збережено!'))
                  .catch(err => {
                    Swal('Дані не збережено!');
                    console.log(err.response.data);
                  });
            },
            edit(item) {
                window.location.href = '/library/servers/' + item.id + '/edit';
            },
            deleteServer(item) {
              Swal.fire({
                title: 'Ви дійсно хочете видалити сервер?',
                text: "Обережно, цю дію не можна скасувати",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Так, видалити',
                cancelButtonText: 'Ні'
              }).then((result) => {
                if (result.value) {
                  axios({
                    method: 'delete',
                    url: '/library/servers/destroy/' + item.id
                  }).then(response => {
                    if(response.data.status === 'success') {
                      this.getServers();
                      Swal.fire('Видалено!', '', 'success')
                    }else{
                      Swal.fire('Не видалено!', response.data.message, 'warning')
                    }
                  });

                }
              })
            },
              externalSearch: function (searchInput) {
                let error = false;
                if (searchInput == null) {
                    $(".invalid-feedback").show();
                    $(".invalid-feedback").html("<span>Введіть пошуковий запит</span>");
                    $(".invalid-feedback").fadeOut(4000);
                    error = true;
                }
                if ($('input:checkbox:checked').length == 0) {
                    $(".invalid-feedback").show();
                    $(".invalid-feedback").html("<span>Оберіть сервера для пошуку.</span>");
                    $(".invalid-feedback").fadeOut(4000);
                    error = true;
                }
                if (!error) {
                    window.location.href = '/library/external-search?query=' + searchInput;
                }
              },
          }
        }
      </script>

      <style scoped>
          table thead th {
            vertical-align: middle;
          }
          input {
            margin-top:10px;
          }
          .input-index {
              margin-top: 0px;
          }
          .btn {
              color: white;
          }
      </style>
